import { logError } from 'services/logging/logging';
import { GenericError } from 'support/helpers/errors/errors';
import { MessageV2DTO, TransactionState } from 'support/types';

type DuplicateAndChangeDocumentState = 'duplicate' | 'replacedBy' | 'replaces' | 'none';

export const shouldDetermineTheDuplicateAndChangeDocumentState = (message: MessageV2DTO | undefined): boolean => {
  if (!message || message.cloned_message_id || message.dropped_error_reasons?.length > 0) {
    return false;
  }

  // Show if message has any of these properties
  return !!(message.replaces_message || message.replaced_by_message);
};

export const determineDuplicateAndChangeDocumentState = (
  message: MessageV2DTO | undefined,
): DuplicateAndChangeDocumentState => {
  if (!message) {
    logError(new GenericError('Message is undefined'));
    return 'none';
  }

  // Priority order: duplicate > replacedBy > replaces
  if (message.state == TransactionState.dropped && message.replaces_message) {
    return 'duplicate';
  }

  if (message.replaced_by_message) {
    return 'replacedBy';
  }

  if (message.replaces_message) {
    return 'replaces';
  }

  logError(
    new GenericError(
      'Could not determine the state for duplicate and change document banner. Message ID: ' + message.id,
    ),
  );

  return 'none';
};
